import React from 'react';
import styled from 'styled-components';
import { useLanguageState } from '../../globalStates/LanguageState';
import ContentPage from './ContentPage';
import TopBar from './TopBar';

interface WrapperProps {
    mainColor: string
}

const Wrapper = styled.main<WrapperProps>`
    overflow-x: hidden;
    overflow-y: auto;
    height: 100vh !important;

    button, button:focus, button:active:focus, button.inverse:not(:disabled):not(.disabled):active:focus {
        color: ${props => props.mainColor || "#6DD400"};
        background-color: #FFF;
        border: 1px solid ${props => props.mainColor || "#6DD400"};
        border-radius: 5px;
    }
    button:focus, button:not(:disabled):not(.disabled):active:focus {
        box-shadow: none;
    }
    button:not(:disabled):not(.disabled):active:focus {
        color: #FFF;
        background-color: ${props => props.mainColor || "#6DD400"};
        border: 1px solid ${props => props.mainColor || "#6DD400"};
    }
    button:hover {
        color: ${props => props.mainColor || "#6DD400"};
        background-color: #FFF;
        border: 1px solid ${props => props.mainColor || "#6DD400"};
    }
    button.inverse {
        color: #FFF;
        background-color: ${props => props.mainColor || "#6DD400"};
        border: 1px solid ${props => props.mainColor || "#6DD400"};
    }
    button.inverse:hover {
        color: #FFF;
        background-color: ${props => props.mainColor || "#6DD400"};
        border: 1px solid ${props => props.mainColor || "#6DD400"};;
    }

    button.btn-link {
        border: none;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-group.invalid-group {
        margin-bottom: 0;
        margin-top: calc(-20px + 0.25rem);
    }

    .form-group .form-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #202428;
        margin-bottom: 10px;
    }

    .form-group .invalid-feedback {
        font-size: 10px;
        line-height: 12px;
        color: #FF0000;
    }

    .form-control {
        border-radius: 5px;
        box-shadow: initial;
        padding: 7px 14.51px;
        background-image: initial;
        background-position: initial;
        background-size: initial;
        font-size: 14px;
        line-height: 16px;
    }
    .form-control:focus {
        box-shadow: initial;
    }

    .form-control.is-valid {
        border: 1px solid #D9D9D9;
    }

    .form-control.is-invalid {
        background: rgba(255, 0, 0, 0.1);
        border: 1px solid #FF0000;
    }

    .form-control[readonly] {
        background: #E5E5E5;
        border: 1px solid #727272;
        opacity: 1;
    }

    .form-check-inline {
        & > .form-check:first-child {
            padding-left: 0;
        }
    }
`

const MainContent: React.FC<{}> = (props) => {
    const branding = useLanguageState().getStrings()
    return (
        <Wrapper mainColor={branding.configuration.maincolor}>
            <TopBar />
            <ContentPage />
        </Wrapper>
    );
}

export default MainContent;